export const testimonials = [
  {
    quote: '五一黑料网是我每天必刷的站点，料够猛、更新够快，而且每条爆料都有理有据，不是那种捕风捉影的标题党。自从关注了他们，娱乐圈的大事小情我都是第一时间知道的。',
    author: '资深吃瓜群众 - 小林',
    verified: true,
    platform: '微博',
  },
  {
    quote: '作为一个做了五年娱乐媒体的老编辑，我可以负责任地说，五一黑料网的爆料准确率在同类平台中是最高的。他们有一整套严格的信源核实机制，这点非常难得。',
    author: '前娱乐媒体主编 - 王老师',
    verified: true,
    platform: '知乎',
  },
  {
    quote: '我之前在某MCN机构工作，亲眼见过很多网红翻车的全过程。五一黑料网的报道基本都跟内部情况吻合，有些细节甚至连我们都不知道，信息渠道确实很广。',
    author: '前MCN运营 - 匿名用户',
    verified: false,
    platform: '小红书',
  },
];

export const platformFeatures = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    description: '7×24小时全网监控，黑料爆出的第一时间我们就到现场，绝不让任何一个猛料从指缝中溜走。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多重核实',
    description: '每条爆料都要经过至少三个独立信源的交叉验证才会发布，杜绝虚假信息和恶意造谣。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '匿名保护',
    description: '爆料者的身份信息全程加密保护，采用银行级安全标准，让线人可以放心地分享信息。',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    description: '汇聚数百万吃瓜群众，每篇文章下的评论区都是大型观点交锋现场，理性讨论不删帖。',
  },
];